// bao migrate skip
import TabPage from "./../factories/tab-page";
import TranslateDialogViewModel from "./../factories/translate-dialog";
import "./../bindings/bao-searcher";
import BaseViewModel from "./../factories/base-view-model2";
import BaoDialog from "./../factories/bao-dialog";
import * as ko from "knockout";
import Bao from "./../services/bao-service";
import { WorkItemTabTypes } from "../constants/work-item-tab-types";

/**
 * Represents a tab in a Work Item interface.
 * Extends the `BaseViewModel` class.
 */
class WorkItemTab extends BaseViewModel {

    //#region Fields

    WorkItemTabUniversalFieldTab: TabPage;
    WorkItemTabFieldTab: Factories.TabPage;
    WorkItemTab1: KnockoutObservable<string> = ko.observable();
    WorkItemTab2: KnockoutObservable<string> = ko.observable();
    WorkItemTab3: KnockoutObservable<string> = ko.observable();
    WorkItemTab4: KnockoutObservable<string> = ko.observable();
    WorkItemTab5: KnockoutObservable<string> = ko.observable();
    Description: KnockoutObservable<string> = ko.observable();
    PreLoad: KnockoutObservable<boolean> = ko.observable();
    AssemblyName: KnockoutObservable<string> = ko.observable();
    ReflectionType: KnockoutObservable<string> = ko.observable();
    WorkItemTabTypeWorkItemTab: KnockoutObservable<string> = ko.observable();
    WorkItemTabTypeObject: KnockoutObservable<any> = ko.observable({});
    WorkItemTabTypeId: KnockoutObservable<string> = ko.observable();
    WorkItemTabType: KnockoutObservable<string> = ko.observable();
    WorkItemTabTypeName: KnockoutObservable<string> = ko.observable();
    AfterInit: KnockoutObservable<boolean> = ko.observable(false);
    ManualCompletion: KnockoutObservable<boolean> = ko.observable(false);
    WebUrl: KnockoutObservable<string> = ko.observable();

    WorkItemTabTypeSearcher: Bindings.baoSearcher = {
        SearchType: "WorkItemTabType",
        ObjectId: this.WorkItemTabTypeId,
        ObjectValue: "WorkItemTabTypeName",
        AutoComplete: true,
        AutoSearch: true,
        SelectedItem: this.WorkItemTabTypeObject
    };

    /**
    * Work Item Tab Client Route
    */
    ClientRoute: KnockoutObservable<string> = ko.observable();

    //#endregion

    //#region Constructors

    /**
     * Creates a new instance of the WorkItemTab class.
     * @param tabPage - The tab page information.
     */
    constructor(tabPage: TabPage) {
        super(tabPage);

        this.WorkItemTabTypeObject.subscribe((value) => {
            if (this.AfterInit()) {
                this.loadTabs();
            }
        });
    }

    //#endregion

    //#region Computed Observables

    /**
     * Computes the WorkItemTab value based on the selected language.
     */
    WorkItemTab = ko.pureComputed<string>({
        read: () => {
            switch (Bao.Session.Language.LanguageIndex()) {
                case 1:
                    return this.WorkItemTab1();
                case 2:
                    return this.WorkItemTab2();
                case 3:
                    return this.WorkItemTab3();
                case 4:
                    return this.WorkItemTab4();
                case 5:
                    return this.WorkItemTab5();
            }
        },
        write: (value) => {
            switch (Bao.Session.Language.LanguageIndex()) {
                case 1:
                    this.WorkItemTab1(value);
                    break;
                case 2:
                    this.WorkItemTab2(value);
                    break;
                case 3:
                    this.WorkItemTab3(value);
                    break;
                case 4:
                    this.WorkItemTab4(value);
                    break;
                case 5:
                    this.WorkItemTab5(value);
                    break;
            }
        }
    });

    //#endregion

    //#region Public Methods

    /**
     * Retrieves the initialization URL for the WorkItemTab.
     * @returns The URL as a string.
     */
    InitUrl() {
        return "WorkItemTab/Init";
    }

    /**
     * Opens the translation dialog for the WorkItemTab.
     */
    Translate() {
        let translateDialog = new TranslateDialogViewModel(this.WorkItemTab1, this.WorkItemTab2, this.WorkItemTab3, this.WorkItemTab4, this.WorkItemTab5);
        translateDialog.Open();
    }

    /**
     * Checks whether all mandatory fields are filled for the WorkItemTab.
     * @returns True if complete, otherwise false.
     */
    CompleteCheck() {

        let isComplete = true;

        if (Bao.Utils.String.IsNullOrEmpty(this.WorkItemTab())) {
            isComplete = false;
        }
        if (Bao.Utils.String.IsNullOrEmpty(this.WorkItemTabTypeName())) {
            isComplete = false;
        }
        if (this.PreLoad() === undefined || this.PreLoad() === null) {
            this.PreLoad(false);
        }
        if (!isComplete) {
            new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgFillMandatorFields"), "info");
        }

        return isComplete;
    }

    /**
    * Initializes the WorkItemTab.
    * @returns A promise that resolves when the tab is initialized.
    */
    init() {
        return super.init().then(() => {
            return this.InitTabController();
        }).then(() => {
            if (!Bao.Utils.String.IsNullOrEmpty(ko.unwrap(this.WorkItemTabType))) {
                this.WorkItemTabTypeObject({ Key: this.WorkItemTabType() });
            }
            this.AfterInit(true);
            this.loadTabs();
        });
    }

    //#endregion

    //#region Private Methods

    /**
    * Internal method to load tabs based on the WorkItemTab type.
    * Destroys all existing tabs and adds new ones.
    */
    private loadTabs = () => {
        this.TabController.DestroyAll();

        // Check if WorkItemTabTypeId is not null before calling toUpperCase
        const tabTypeId = this.WorkItemTabTypeId();
        if (tabTypeId && tabTypeId.toUpperCase() == WorkItemTabTypes.UniversalField) {
            this.WorkItemTabUniversalFieldTab = new TabPage();
            this.WorkItemTabUniversalFieldTab.IsClosable(false);
            this.WorkItemTabUniversalFieldTab.Url("WorkItemTabUniversalField");
            this.WorkItemTabUniversalFieldTab.AutoSelect = true;
            this.TabController.AddTab(this.WorkItemTabUniversalFieldTab);

            $.when(Bao.Session.GetMessage("msgUniversalFieldTitle")).then(() => {
                this.WorkItemTabUniversalFieldTab.Title(Bao.Session.GetMessage("msgUniversalFieldTitle")());
            });
        }
    }

    //#endregion
}
export default WorkItemTab;